import React from 'react';

const CandidatesHeader = ({
	heading = 'Campus Candidates',
	extraContent,
}: {
	heading?: string;
	extraContent?: React.ReactNode;
}) => {
	return (
		<div className="min-h-[57px] flex justify-between items-center py-2 pt-6 sm:pt-[10px] border-b border-[#EBEBF0] dark:border-[#555770] border-solid">
			<div className="text-[18px] md:text-xl font-[500] md:font-semibold text-[#1C1C28] dark:text-white">{heading}</div>
			{extraContent}
		</div>
	);
};

export default CandidatesHeader;
